import { ComponentPropsWithoutRef, forwardRef } from "react";

/**
 * ListViewOptionCell component for rendering a cell within a listview option.
 *
 * Features:
 * - Renders a grid cell for option content
 * - Supports custom content and layout
 * - Accessible with proper ARIA attributes
 *
 * @example
 * <ListView.OptionCell>Custom cell content</ListView.OptionCell>
 */
export const ListViewOptionCell = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<"div">
>((props, ref) => {
  const { ...rest } = props;
  return (
    <div role="gridcell" data-anv="listview-option-cell" {...rest} ref={ref} />
  );
});

ListViewOptionCell.displayName = "ListViewOptionCell";
